<script lang="ts">
    import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
    import { getContext, onMount } from "svelte";
    import { push } from 'svelte-spa-router'
    import { ContextTokens } from "../contexts/ContextTokens";
    import type { GroupStoreInfo } from "$src/domain/users/UserGroupStoreAccess";

    let { activeGroupStore }  : AuthContext = getContext(ContextTokens.Auth);

    $: challengeRedirect($activeGroupStore);

    onMount( () => {
        challengeRedirect($activeGroupStore);
    })

    function challengeRedirect(activeGs: GroupStoreInfo | undefined) {
        if( activeGs?.groupStoreId ) {
            push(`/gs/${activeGs.groupStoreId}/projects`)
        }
    }

</script>


